import React from 'react';
import { object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Form, { Botao as BotaoForm, Campo } from 'Component/Form';
import Icone from 'Component/Icone';
import Modal from 'Component/Modal';
import Usuario from 'Interface/Usuarios';
import { useEditarUsuarioMutation } from 'Service';

interface Props {
  exibir: boolean;
  aoFechar: () => void;
  usuarioId?: number;
}

const regras = object({
  senha: string()
    .min(6, 'Deve ter ao menos 6 caracteres')
    .required('Obrigatório'),
});

const AlterarSenha = ({
  exibir,
  aoFechar,
  usuarioId,
}: Props): React.ReactElement => {
  const toast = useToast();
  const [editarUsuario] = useEditarUsuarioMutation();

  const enviar = async (dados: Usuario): Promise<void> => {
    try {
      if (usuarioId) {
        await editarUsuario({ ...dados, id: usuarioId }).unwrap();

        toast({ conteudo: 'Senha alterada com sucesso!', tema: 'success' });

        aoFechar();
      }
    } catch (error) {
      toast({
        titulo: 'Erro ao editar',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <Modal
      titulo="Alterar senha do usuário"
      exibir={exibir}
      aoFechar={aoFechar}
    >
      <Form onSubmit={enviar} regras={regras}>
        <Campo
          type="password"
          name="senha"
          rotulo="Senha"
          prefixar={<Icone nome="lock-fill" />}
          ajuda="Mínimo de 6 caracteres"
        />
        <div className="d-flex gap-2">
          <BotaoForm>Enviar</BotaoForm>
          <Botao tema="light" onClick={aoFechar}>
            Cancelar
          </Botao>
        </div>
      </Form>
    </Modal>
  );
};

export default AlterarSenha;
